/**
 * compareIds.js — Lecture du paramètre ?ids= des routes de comparaison
 * (propriétaire /compare, vétérinaire /vet/compare).
 *
 * Une comparaison porte sur MAX_COMPARE_SESSIONS sessions au plus (lisibilité
 * des courbes superposées et du tableau côte à côte). Le bouton Comparer de la
 * liste applique déjà la limite ; une URL forgée ou ancienne peut en porter
 * davantage : on garde les premières et on le signale (truncated), plutôt que
 * de refuser le lien.
 */
export const MAX_COMPARE_SESSIONS = 4;

export function parseCompareIds(raw) {
  const all = (raw || '').split(',').filter(Boolean);
  return { ids: all.slice(0, MAX_COMPARE_SESSIONS), truncated: all.length > MAX_COMPARE_SESSIONS };
}
